import { FlightPlanData } from '../../../basis/flight/models/basisFlightModel';

export interface ControlGpState {
  controlGpList: ControlGpData[] | undefined;
  controlGroupAuthInfo: ControlGroupAuthData[] | undefined;
}

// export interface ControlGpWeatherState {
//   controlWheather: rescontrolweatherData | undefined;
// }

export interface ControlGpFlightPlanState {
  controlGpFltPlanList: ControlGpFlightPlanDataList | undefined;
  controlGpContains: ControlGpPlanContainsRS | undefined;
}

export interface ControlGpLogState {
  controlGpWarnLog: ControlGpWarnLogList | undefined;
  controlGpArcrftWarnList: ControlGpArcrftWarnList | undefined;
}

export interface ControlGpHisState {
  controlGpHistory: ControlGpHistoryData[] | undefined;
}

export interface ControlGpDtlState {
  controlGpDetail: ControlGpDtlData | undefined;
  controlDetail: ControlDetailData | undefined;
  controlWheather: rescontrolweatherData | undefined;
}

export interface ControlGpCountState {
  controlGpCountDrone: ControlGpCountData[] | undefined;
  controlGpCountFlight: ControlGpCountData[] | undefined;
}

export interface ControlGpCountData {
  gps: ControlGpData | undefined;
  type: string;
}

// export interface ControlGroupAuthState {
//   controlGroupAuthInfo: ControlGroupAuthData[] | undefined;
// }
// const [count, setCount] = useState({
//   drone: [],
//   flight: []
// });
export interface ControlGpHistoryData {
  objectId: String;
  lat: number;
  lng: number;
}

export interface ControlDetailData {
  cntrlId: string;
  cntrlStDt: Date;
  cntrlEndDt: Date;
  arcrftSno: number;
  prdctNum: string;
  prdctCmpnNm: string;
  wghtTypeCd: string;
  imageUrl: string;
  arcrftTypeCd: string;
  arcrftModelNm: string;
  cameraYn: string;
  insrncYn: string;
  stAreaNm: string;
  ownerNm: string;
  hpno: string;
  telno: string;
  items: [];
  area1: string;
  area2: string;
  area3: string;
  landNm: string;
  landNum: string;
}

export interface ControlGpDtlData {
  messageTypeCd: string;
  controlId: string;
  objectTypeCd: string;
  objectId: string;
  objectType: string;
  betteryLevel: number;
  betteryVoltage: number;
  lat: number;
  lng: number;
  elev: number;
  elevType: string;
  speed: number;
  speedType: string;
  moveDistance: number;
  moveDistanceType: string;
  dronStatus: string;
  controlStartDt: string;
  heading: number;
}

export interface ControlGpData {
  messageTypeCd: string;
  controlId: string;
  objectTypeCd: string;
  objectId: string;
  objectType: string;
  betteryLevel: number;
  betteryVoltage: number;
  moveDistance: number;
  moveDistanceType: string;
  lat: number;
  lng: number;
  elev: number;
  elevType: string;
  speed: number;
  speedType: string;
  dronStatus: string;
  controlStartDt: string;
  heading: number;
  controlWarnCd: boolean;
  controlWarnNotyCd: boolean;
}
export interface ControlweatherData {
  nx: string;
  ny: string;
}
export interface ControlGroupAuthData {
  cstmrSno: number;
  userId: string;
  groupId: string;
  groupNm: string;
  groupAuthCd: string;
  arcrftSno: number;
  idntfNum: string;
  createUserId: string;
  trmnlId: string;
}

export interface ControlGpFlightPlanDataList
  extends Array<ControlGpFlightPlanData> {}
export interface ControlGpFlightPlanData {
  planSno?: number;
  groupId: string;
  cstmrSno: number;
  memberName: string;
  email: string;
  hpno: string;
  clncd: string;
  addr: string;
  addrDtlCn: string;
  zip: string;
  schFltStDt: string;
  schFltEndDt: string;
  fltPurpose: string;
  aprvlYn: string;
  delYn: string;
  createUserId: string;
  createDt: string;
  updateUserId: string;
  updateDt: string;
  areaList?: FlightPlanAreaDataList | undefined;
}

export interface ControlGpWarnLogData {
  warnLogSno: number;
  cntrlId: String;
  createDt: String;
  idntfNum: String;
}

export interface ControlGpWarnLogList extends Array<ControlGpWarnLogData> {}

export interface FlightPlanAreaDataList extends Array<FlightPlanAreaData> {}

export interface FlightPlanAreaData {
  planAreaSno?: number;
  planSno: number;
  areaType: string;
  fltMethod: string;
  bufferZone: number;
  fltElev: string;
  createUserId?: string;
  createDt?: string;
  updateUserId?: string;
  updateDt?: string;
  coordList?: FlightPlanAreaCoordDataList | undefined;
  bufferCoordList?: FlightPlanAreaCoordDataList | undefined;
}

export interface FlightPlanAreaCoordDataList
  extends Array<FlightPlanAreaCoordData> {}

export interface FlightPlanAreaCoordData {
  planAreaCoordSno?: number;
  planAreaSno?: number;
  lat: number;
  lon: number;
  createUserId?: string;
  createDt?: string;
  // docState: string
}

export interface ControlGpArcrftWarnRq {
  cntrlId: string;
}

export interface ControlGpArcrftWarnData {
  cntrlId: string;
  warnType: string;
  idntfNum: string;
  occurDt: string;
  createDt: string;
  warnCount: number;
}

export interface rescontrolweatherData {
  items: [];
}
export interface ControlGpArcrftWarnList
  extends Array<ControlGpArcrftWarnData> {}

export interface ControlGpPlanContainsRQ {
  idntfNum: string;
  lat: number;
  lon: number;
  planList: FlightPlanData[];
}

export interface ControlGpPlanContainsRS {
  contains: boolean;
  idntfNum: string;
}

export interface ResponseControlGpHistory {
  data: ControlGpHistoryData[];
}

export interface ResponseControlGpWarnLog {
  data: ControlGpWarnLogData[];
}

export interface ResponseControlGroupAuth {
  data: ControlGroupAuthData[];
}

export const initiaResponseControlGpData = {
  controlGpList: undefined,
  controlGpDetail: undefined,
  controlGpHistory: undefined,
  controlGpWarnLog: undefined,
  controlDetail: undefined,
  controlGroupAuthInfo: undefined,
  controlGpFltPlanList: undefined,
  controlGpWarnLogList: undefined,
  controlGpContains: undefined,
  controlGpArcrftWarnList: undefined,
  controlweatherData: undefined,
  rescontrolweatherData: undefined,
  controlWheather: undefined,
  controlGpCountDrone: undefined,
  controlGpCountFlight: undefined
};
